import { Injectable } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { LanguageService } from './language';
import { GenericConfig } from '@signature-it/ngx-generic/config';
import { MatSnackBar } from '@angular/material/snack-bar';

declare let toastr: any;

@Injectable({
    providedIn: 'root'
})
export class PageNotificationService {

    static optionsDefault: object = {
        horizontalPosition: 'end',
        verticalPosition: 'bottom',
        duration: 5000,
        direction: 'rtl',
        actionLabel: 'x'
    };

    private body: string;
    private code: number;
    private options: object;
    private debugMode = GenericConfig.debugMode === false ? false : true;


    constructor(private translateSvc: TranslateService,
                private langSvc: LanguageService,
                private _snackBar: MatSnackBar) {
        this.body = '';
        this.code = 0;
        this.options = PageNotificationService.optionsDefault;
    }

    public set(...params): this {
        if (!params.length) {
            throw new Error('No parameters were specified');
        } else  {
            try {
                let body = params[0].json();
                if (typeof body === 'string') {
                    this.body = body;
                } else {
                    this.body = params[0]._body;
                }
            } catch (e) {
                this.body = (params[0].error && typeof params[0].error === 'string') ? params[0].error :
                    params[0].toString() ?  params[0].toString() : '';
            }
            this.code = params[1] || 0;
        }
        this.body = this.body.length ? this.translateSvc.instant(this.body) : this.body;
        this.code = (Number(this.code) > 0) ? this.code : 0;
        // LTR/RTL options
        let isRTL = this.langSvc.isCurrentRTL();
        this.options = Object.assign(
            this.options,
            {
                direction: isRTL ? 'rtl' : 'ltr'
            }
        );
        if (params[2]) {
            this.options = Object.assign(
                this.options,
                params[2]
            );
        }
        return this;
    }

    public show(): void {
        if (!this.debugMode) {
            return null;
        }
        switch (this.code) {
            case 200:
                this.options['panelClass'] = ['bg-success'];
                break;
            case 400:
            case 401:
            case 403:
            case 404:
                this.options['panelClass'] = ['bg-warning'];
                break;
            case 500:
            default:
                this.options['panelClass'] = ['bg-danger'];
                break;
        }
        this.options['panelClass'].push('text-white');
        this._snackBar.open(this.body, this.options['actionLabel'], this.options);
    }

}
